import './less/boxAlert.less';
import {Translate} from '../../../hoc/translate'

const BoxAlert = ((props) => {

})();

export default Translate(BoxAlert);


// WEBPACK FOOTER //
// ../components/UI/boxAlert/boxAlert.js